const scheduleBrowserIdleCallback = (callback, delayMs) => {
  let cancelIdleCallback = () => {};
  const timeoutId = window.setTimeout(() => {
    if (typeof window.requestIdleCallback === "function") {
      const idleCallbackId = window.requestIdleCallback(callback);
      cancelIdleCallback = () => window.cancelIdleCallback(idleCallbackId);
      return;
    }
    const animationFrameId = window.requestAnimationFrame(callback);
    cancelIdleCallback = () => window.cancelAnimationFrame(animationFrameId);
  }, delayMs);
  return () => {
    window.clearTimeout(timeoutId);
    cancelIdleCallback();
  };
};
export { scheduleBrowserIdleCallback };